module.exports = __webpack_public_path__ + "7247cb8313ead8d044d722c1a9719179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modal-logo.png
// module id = 99
// module chunks = 1